import type { FaireProductEntity } from "../../entity_types/product";

export const p_tx2bvvexhc: FaireProductEntity = {
  token: "p_tx2bvvexhc",
  type: "product",
  name: "Thank You Folk Flowers",
  brandToken: "b_1sahwzac",
  brandName: "Hammerpress",
  imageUrl:
    "https://cdn.faire.com/fastly/88a397548332ef1bfbacb5b808c83f37949a24c8c92129f4f92cf7bd21dca834.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e27f81f82ed28fa489b03df58fc2fd451985c5f349e546daa1e9ea087b4efcbb.jpeg",
    "https://cdn.faire.com/fastly/100bc0ded5d511dec803716b05ed8387b32b53eafaa099afd1f905b6997ae6ef.jpeg",
  ],
  priceDollars: 3,
  description:
    'Folding note card with kraft envelope. Letterpress printed on 110lb. Recycled white paper. Blank inside.\n\nCard size: 4.25" x 5.50" (folded).\n\nPackaged in plant-based polylactic acid (PLA) certified compostable bag.\n\nDesigned and letterpress printed at our studio in Kansas City, Missouri. Made in USA.\nAlso available as a boxed set of 6 here.',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:07.864Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
